<template>
  <vue-pdf-app pdf="./pdf/help.pdf" theme="light" :config="config" />
</template>
<script>
import VuePdfApp from 'vue-pdf-app';
import 'vue-pdf-app/dist/icons/main.css';

export default {
  components: {
    VuePdfApp
  },
  computed: {
    config() {
      return {
        toolbar: {
          toolbarViewerRight: {
            openFile: false,
            viewBookmark: false
          }
        },
        secondaryToolbar: false,
        sidebar: false
      };
    }
  },
  head() {
    return {
      link: function () {
        return [
          {
            rel: 'resource',
            type: 'application/l10n',
            href: `pdf/locale_${this.$route.params.locale || this.$i18n.locale || 'pl'}`,
            id: 'pdfLocale'
          }
        ];
      }
    };
  }
};
</script>
<style lang="scss" scoped>
.pdf-app.light {
  --pdf-toolbar-color: var(--v-primary-base);
  --pdf-input-color: #606060;
}
::v-deep {
  .toolbar {
    z-index: 6 !important;
  }
}
</style>